const FloorPlanAmenity = ({ amenity = '', availableInSelectUnits = false, floorPlanId = '', id = '' } = {}) => ({
  amenity: String(amenity),
  availableInSelectUnits: Boolean(availableInSelectUnits),
  floorPlanId: String(floorPlanId),
  id: String(id),
});

export default FloorPlanAmenity;

export type FloorPlanAmenityProps = ReturnType<typeof FloorPlanAmenity>;
